import type { GetRecurringRevenueReportResponse } from '@vy/api-definition';
import { GetRecurringRevenueReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined, withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useRecurringRevenueReport(
  reportId?: string,
  options?: CustomUseQueryOptions<GetRecurringRevenueReportResponse>,
) {
  const getRecurringRevenueReportQuery = useQuery(
    queryKeys.recurringRevenueReport(withDefault(reportId, '')),
    async () => {
      const api = getPrivateApi();
      const recurringRevenueReportResponse = await api.getRecurringRevenueReportRaw({
        reportId,
      });

      const recurringRevenueReportJson = await recurringRevenueReportResponse.raw.json();

      return GetRecurringRevenueReportResponseSchema.parse(recurringRevenueReportJson);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getRecurringRevenueReportQuery.data, 'getRecurringRevenueReportQuery data');

  return getRecurringRevenueReportQuery;
}


